import { render, staticRenderFns } from "./CrmDuplicates.vue?vue&type=template&id=032202c8"
import script from "./CrmDuplicates.vue?vue&type=script&lang=js"
export * from "./CrmDuplicates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports